"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalContainer = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
const ModalContainer = exports.ModalContainer = _styledComponents.default.div.withConfig({
  displayName: "RequestToolModalstyles__ModalContainer",
  componentId: "sc-11h6keq-0"
})(["position:absolute;top:-200px;"]);